import { getTimeZone } from 'utils/time-zone';

export enum BATCH_STATES {
  CREATED = 1,
  RUNNING = 3,
  SUCCEEDED = 4,
  STOPPED = 98,
  FAILED = 99,
}

export const headers = [
  {
    name: 'ID',
    sort_direction: 'default',
    sort_key: 'batch_id',
    width: '90px',
    uuid: 1,
  },
  {
    name: 'Batch Name',
    flex_grow: 1,
    width: '125px',
    sort_direction: 'default',
    sort_key: 'batch_name',
    uuid: 2,
  },
  {
    name: 'State',
    sort_direction: 'default',
    sort_key: 'batch_state_sort',
    width: '140px',
    uuid: 3,
  },
  {
    name: 'Jobs',
    width: '80px',
    uuid: 4,
  },
  {
    name: 'Queued',
    width: '80px',
    uuid: 5,
  },
  {
    name: 'Starting',
    width: '80px',
    uuid: 6,
  },
  {
    name: 'Stopped',
    width: '80px',
    uuid: 7,
  },
  {
    name: 'Running',
    width: '80px',
    uuid: 8,
  },
  {
    name: 'Succeded',
    width: '80px',
    uuid: 9,
  },
  {
    name: 'Failed',
    width: '80px',
    uuid: 10,
  },
  {
    name: 'Created By',
    width: '150px',
    sort_direction: 'default',
    sort_key: 'created_by',
    uuid: 11,
  },
  {
    name: `Created At (${getTimeZone()})`,
    width: '150px',
    sort_direction: 'default',
    sort_key: 'sort_datetime',
    uuid: 12,
  },
];
